const expData = [
    {
        id: "1",
        org: "BOCK Chain",
        title: "Software Engineer Intern",
        date: "Nov 2024 - Feb 2025",
        location: "Remote",
        type: "Internship",
        description: "Designing user interfaces and implementing backend services for web-based applications.",
        responsibilities: [
            "Designing intuitive user interfaces for web applications",
            "Implementing secure backend services for user authentication",
            "Developing file management systems with encryption",
            "Ensuring responsive design across all device types"
        ],
        achievements: [
            "Delivered project 2 weeks ahead of schedule",
            "Received excellent feedback from supervisors",
            "Responsive design across all device types"
        ],
        technologies: ["React", "TailwindCSS", "Firebase"]
    },
    {
        id: "2",
        org: "BSQ Technology",
        title: "Web Developer Intern",
        date: "June 2023 - Aug 2023",
        location: "Hybrid",
        type: "Internship",
        description: "Designed user interfaces and implemented backend services for property management applications.",
        responsibilities: [
            "Designed responsive user interfaces for property management platform",
            "Implemented secure user authentication and authorization systems",
            "Developed property management features including listings and search",
            "Ensured responsive design across all device types"
        ],
        achievements: [
            "Delivered project 2 weeks ahead of schedule",
            "Received excellent feedback from supervisors",
            "Improved application performance by 25%"
        ],
        technologies: ["HTML5", "CSS3", "JavaScript","SpringBoot", "MySQL"]
    }
];

export default expData;
